// src/common/utils/permissionUtils.ts

import { rules, Permission } from "../../../abac.config";
import {
  ADMIN_ROLES,
  ESTIMATION_ROLES,
  RENTAL_EQUIPMENT_ROLES,
  DENY_CHART_AND_LISTING,
  DENY_SHOP_PERSONAL,
  DENY_RECEIVING,
  DENY_TRANSPORT,
  DENY_MAINTENANCE,
  DENY_INVENTORY,
  DENY_FIELD_CREW
} from "./roleUtils";

export const hasRole = (roleKey, roles) =>
  !!roleKey && roles.includes(roleKey);

export const hasPermission = (roleKey, permission) => {
  return !!roleKey && !!rules?.[roleKey]?.[permission];
};

/* -------------------- ACCESS HELPERS -------------------- */

export const canAccessHumanResource = (roleKey) =>
  hasRole(roleKey, ADMIN_ROLES);

export const canAccessEstimation = (roleKey) =>
  hasRole(roleKey, ESTIMATION_ROLES);

export const canAccessRentalEquipment = (roleKey) =>
  hasRole(roleKey, RENTAL_EQUIPMENT_ROLES);

export const denyChartAndListing = (roleKey) =>
  hasRole(roleKey, DENY_CHART_AND_LISTING);

export const denyShopPersonal = (roleKey) =>
  hasRole(roleKey, DENY_SHOP_PERSONAL);

export const denyReceiving = (roleKey) =>
  hasRole(roleKey, DENY_RECEIVING);

export const denyTransport = (roleKey) =>
  hasRole(roleKey, DENY_TRANSPORT);

export const denyMaintenance = (roleKey) =>
  hasRole(roleKey, DENY_MAINTENANCE);

export const denyInventory = (roleKey) =>
  hasRole(roleKey, DENY_INVENTORY);

export const denyFieldCrew = (roleKey) =>
  hasRole(roleKey, DENY_FIELD_CREW);

export const canAccessMasterData = (roleKey) =>
  hasPermission(roleKey, Permission.MASTER_WRITE);
